module.exports = __webpack_public_path__ + "files/5657ceb46ad169c959f4e822ce9d0339.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-italic-webfont.ttf
 ** module id = 891
 ** module chunks = 0
 **/